import { useTranslation } from 'react-i18next';
import CommonSetErrorType from '../CommonSetError.type';
import { useCommonErrorHandler } from '../useErrorHandler';

const useRoleNotFoundErrorHandler = (setError?: CommonSetErrorType) => {
  const { t } = useTranslation();

  const { handler } = useCommonErrorHandler({
    setError,
    errorCode: 'ROLE_NOT_FOUND',
    errorMessage: t('settings.sections.permission.subsections.role.controls.errors.notFound'),
  });

  return handler;
};

export default useRoleNotFoundErrorHandler;
